import { render, staticRenderFns } from "./asignarRol.vue?vue&type=template&id=18bb8334&"
import script from "./asignarRol.vue?vue&type=script&lang=js&"
export * from "./asignarRol.vue?vue&type=script&lang=js&"
import style0 from "./asignarRol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports